export { subscriptionToUpdate } from './client';
import { getClient } from './client';

export default getClient;



// WEBPACK FOOTER //
// ./src/services/app-sync/index.ts